import { STATS } from "@/lib/data";

const StatsBar = () => {
  return (
    <section className="bg-ink text-white py-16 lg:py-20" data-testid="stats-section">
      <div className="container-tm">
        <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-7 gap-y-10 gap-x-4">
          {STATS.map((s, i) => (
            <div
              key={i}
              data-testid={`stat-item-${i}`}
              className="text-center group"
            >
              <div className="font-serif text-3xl md:text-4xl lg:text-5xl text-gold leading-none transition-transform duration-500 group-hover:scale-105 inline-block">
                {s.value}
              </div>
              <div className="mt-3 text-[10px] uppercase tracking-[0.22em] text-white/55 font-semibold leading-relaxed px-2">
                {s.label}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default StatsBar;
